import React from "react";

export const LadderIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width="49"
    height="48"
    viewBox="0 0 49 48"
    fill="none"
    {...props}
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      opacity="0.5"
      x="15.4648"
      y="6.67456"
      width="18.5701"
      height="6"
      fill="#078DEE"
    />
    <rect
      opacity="0.5"
      x="15.4648"
      y="21.781"
      width="18.5701"
      height="6"
      fill="#078DEE"
    />
    <rect
      opacity="0.5"
      x="15.4648"
      y="36.887"
      width="18.5701"
      height="6"
      fill="#078DEE"
    />
    <rect
      opacity="0.4"
      x="15.4648"
      y="21.781"
      width="2.62622"
      height="6"
      fill="#078DEE"
    />
    <rect
      opacity="0.4"
      x="15.4648"
      y="6.67456"
      width="2.62622"
      height="6"
      fill="#078DEE"
    />
    <rect
      opacity="0.4"
      x="15.4648"
      y="36.887"
      width="2.62622"
      height="6"
      fill="#078DEE"
    />
    <rect
      opacity="0.8"
      x="9.46484"
      y="48"
      width="48"
      height="6"
      rx="3"
      transform="rotate(-90 9.46484 48)"
      fill="#078DEE"
    />
    <path
      d="M12.4648 48C14.1217 48 15.4648 46.6569 15.4648 45L15.4648 3C15.4648 1.34315 14.1217 7.24234e-08 12.4648 0C12.4648 6.2248 12.4648 11.9599 12.4648 13.6168V41.0726C12.4648 42.7295 12.4648 44.3579 12.4648 48Z"
      fill="#078DEE"
    />
    <rect
      opacity="0.8"
      x="34.0352"
      y="48"
      width="48"
      height="6"
      rx="3"
      transform="rotate(-90 34.0352 48)"
      fill="#078DEE"
    />
    <path
      d="M37.0352 48C38.692 48 40.0352 46.6569 40.0352 45L40.0352 3C40.0352 1.34315 38.692 7.24234e-08 37.0352 0C37.0352 6.2248 37.0352 11.9599 37.0352 13.6168V41.0726C37.0352 42.7295 37.0352 44.3579 37.0352 48Z"
      fill="#078DEE"
    />
  </svg>
);
